import React from 'react';
import { UseFormRegister, FieldValues, FieldErrors, RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface CheckboxProps{
    name: string;
    register: UseFormRegister<FieldValues>;
    errors: FieldErrors<FieldValues>;
    options?: RegisterOptions<FieldValues, string> | undefined;
    children: React.ReactNode;
    value: boolean;
    onChange?: () => void;
}

/**
 * Matches the uikit's `.toggle-checkbox` markup: a transparent native input covered
 * by a `.checkbox` label carrying the visual state. The label uses htmlFor so clicking
 * the box toggles the input natively.
 */
const Checkbox = (props: CheckboxProps) => {
  const { t } = useTranslation();
  return (
    <div className='row u-mb-2'>
      <div className='col'>
        <div className='d-flex align-items-center'>
          <div className='toggle-checkbox'>
            <input
              type='checkbox'
              id={props.name}
              {...props.register(props.name, props.options)}
            />
            <label className='checkbox' htmlFor={props.name} aria-hidden='true'></label>
          </div>
          {props.children}
        </div>
        {props.errors[props.name] &&
          <span className='u-color-error small' role="alert" aria-live="assertive">{t('REQUIRED')}</span>}
      </div>
    </div>
  )
};

export default Checkbox
